export const VL = "vl";
export const EA = "ea";
export const NRW = "nrw";